<template>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!-- <form role="form" @submit.prevent="saveReceiver"> -->
      <form role="form">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold row"><i class="fi fi-brands-whatsapp"
              style="color: #00AB4F; margin-right: 10px; margin-left: 10px;"></i> Scan QR WhatsApp</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <i class="fi fi-rr-cross-small"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-control bos-alert-primary lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
            <div class="row">
              <div class="col-auto d-flex align-items-center">
                <i class="fi fi-rr-info d-flex align-items-center"></i>
              </div>
              <div class="col d-flex align-items-center">
                <div class="text-md">
                  Dengan menggunakan fitur scan WhatsApp, anda dapat mengirimkan pesan otomatis kepada penerima saat
                  paket dijemput, sedang dikirim, atau jika mengalami kendala pengantaran.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group px-0 px-sm-3" style="display: flex; justify-content: center; align-items: center;">
            <div>
              <h6>
                <span class="text-sm bd-content-title">Untuk memulai mengirimkan notifikasi ke penerima secara otomatis,
                  kamu dapat scan QR dengan WhatsApp kamu.</span>
              </h6>
              <div class="row">
                <div class="row col-8">
                  <div class="col-1">
                    <div class="text-md">1.</div>
                  </div>
                  <div class="col-11">
                    <div class="text-md">Ini adalah layanan premium yang bisa didapatkan secara gratis dari bosCOD yang
                      digunakan untuk notifikasi transaksi kamu</div>
                  </div>
                  <div class="col-1">
                    <div class="text-md">2.</div>
                  </div>
                  <div class="col-11">
                    <div class="text-md">Kamu setuju untuk tidak menggunakan layanan ini untuk spam dan mengirimkan
                      pesan massal</div>
                  </div>
                  <div class="col-1">
                    <div class="text-md">3.</div>
                  </div>
                  <div class="col-11">
                    <div class="text-md">Kami sarankan untuk tidak menggunakan nomor telepon baru (kurang dari 1 bulan)
                      atau nomor telepon pribadi untuk meminimalisir resiko nomor terblokir oleh pihak WhatsApp</div>
                  </div>
                  <div class="col-1">
                    <div class="text-md">4.</div>
                  </div>
                  <div class="col-11">
                    <div class="text-md">Fitur ini tidak ter-afiliasi langsung dengan sistem resmi dari WhatsApp, jadi
                      mohon digunakan dengan bijak</div>
                  </div>
                </div>
                <div class="col-4">
                  <div id="qr_code" v-bind:class="{ 'skeleton-item': loading }" style="width: 200px; height: 200px;">
                    <qr-code :text="qr_code" :size="200" title="QR Code" style="pointer-events: none;"></qr-code>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-control bos-alert-warning lh-1 d-flex align-items-center h-100" style="margin-bottom: 15px;">
            <div class="row">
              <div class="col-auto d-flex align-items-center">
                <i class="fi fi-rr-info d-flex align-items-center"></i>
              </div>
              <div class="col d-flex align-items-center">
                <div class="text-md">
                  Belum menemukan fitur scan WhatsApp? Yuk, langsung cek tutorial lengkapnya di sini! <a type="button"
                    style="color: #00AB4F; font-weight: bold;" @click="tutorial()">Tutorial Scan WhatsApp</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueQRCodeComponent from 'vue-qrcode-component';
Vue.component('qr-code', VueQRCodeComponent);

export default {
  name: "WhatsAppQRScan",
  emits: ['tutorialClicked', 'afterScan', 'rescan'],
  data() {
    return {
      phone: null,
      qr_code: '',
      loading: false
    }
  },
  methods: {
    async getQRCode() {
      if (this.loading && this.qr_code === '') {
        return;
      }

      try {
        const data_token = await JSON.parse(localStorage.getItem('APP_TOKEN'));
        const token = data_token.accessToken;
        const waUrl = process.env.VUE_APP_WA_SERVICE_URL;

        this.qr_code = '';
        this.loading = true;

        const response = await fetch(`${waUrl}/api/whatsapp/qr-code` + (this.phone != null ? `?phone=${this.phone}` : ''), {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const reader = response.body.getReader();

        while (true) {
          const { done, value } = await reader.read()

          if (done) {
            break;
          }

          // Mengkonversi Uint8Array ke text
          const text = new TextDecoder().decode(value);

          if (text == 'auth_failure') {
            this.customSwal.fire({
              html: '<img src="' + this.getImage('error') + '" class="d-block w-75 m-auto" />Maaf, terjadi kesalahan saat menyambungkan.<br />Silahkan scan barcode WhatsApp lagi.',
              showConfirmButton: true,
              confirmButtonText: 'Scan Kembali',
              showCancelButton: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.loading = true;
                this.qr_code = '';
                this.$emit('rescan');
              }
            });
          } else if (text == 'connected' || text == 'authenticated' || text == 'disconnected') {
            this.$emit('afterScan', text);
            this.loading = false;
            this.qr_code = '';
            this.phone = null;
          } else {
            this.qr_code = text;
            this.loading = false;
          }
        }
      } catch (error) {
        console.error('Error:', error);
        this.loading = false;
        this.qr_code = '';
        this.phone = null;
      }
    },
    tutorial() {
      this.$emit('tutorialClicked');
    }
  }

}
</script>
